import Cursor from "components/cursor.js";
import Cookies from "components/cookies.js";

import React from "react";
import { Router } from "react-static";
import { hot } from "react-hot-loader";
import { NavLink } from "react-router-dom";
import Routes from "react-static-routes";
import { Helmet } from "react-helmet";
import seoImg from "assets/soju.png";
import LoadingScreen from "react-loading-screen";
import "./app.css";

const page = (match, location) => {
  if (location.pathname === "/about" || location.pathname === "/contact") {
    return false;
  }
  return true;
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, color: "#ffffff" };
    this.loaded = this.loaded.bind(this);
  }
  componentDidMount() {
    this.loaded();
    this.timerID = setInterval(() => this.blink(), 400);
  }
  componentWillUnmount() {}

  loaded() {
    setTimeout(() => {
      this.setState({ loading: false });
      clearInterval(this.timerID);
    }, 1500);
  }
  blink() {
    this.setState((prevState, props) => {
      if (prevState.color == "#ffffff") {
        return { color: "#000000" };
      } else if (prevState.color == "#000000") {
        return { color: "#ffffff" };
      }
    });
  }
  render() {
    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="#000000"
        textColor={this.state.color}
        text="soju.studio"
      >
        <Router>
          <Cursor>
            <Helmet>
              <title>soju.studio</title>
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
              />

              <meta
                name="description"
                content="soju.studio is a Vienna-based team of young, multidisciplinary creatives with a focus on graphic design, photography and visual design in both, traditional and digital media."
              />
              <meta name="image" content={seoImg} />
              <meta name="twitter:card" content="summary" />
              <meta name="twitter:title" content="soju.studio" />
              <meta
                name="twitter:description"
                content="soju.studio is a Vienna-based team of young, multidisciplinary creatives with a focus on graphic design, photography and visual design in both, traditional and digital media."
              />
              <meta name="twitter:image" content={seoImg} />
              <meta property="og:url" content="https://soju.studio" />
              <meta property="og:type" content="website" />
              <meta property="og:title" content="soju.studio" />
              <meta
                property="og:description"
                content="soju.studio is a Vienna-based team of young, multidisciplinary creatives with a focus on graphic design, photography and visual design in both, traditional and digital media."
              />
              <meta property="og:image" content={seoImg} />
              <link
                rel="apple-touch-icon"
                sizes="180x180"
                href="favicon/apple-touch-icon.png"
              />
              <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="favicon/favicon-32x32.png"
              />
              <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="favicon/favicon-16x16.png"
              />
              <link rel="manifest" href="favicon/site.webmanifest" />
              <link
                rel="mask-icon"
                href="favicon/safari-pinned-tab.svg"
                color="#000000"
              />
              <meta name="msapplication-TileColor" content="#ffffff" />
              <meta name="theme-color" content="#ffffff" />
            </Helmet>
            <div className="wrapper">
              <div className="header">
                <nav>
                  <NavLink
                    to="/"
                    isActive={page}
                    activeStyle={{
                      color: "white",
                    }}
                  >
                    soju.studio
                  </NavLink>
                  <NavLink
                    to="/about"
                    activeStyle={{
                      color: "white",
                    }}
                  >
                    about
                  </NavLink>
                  <NavLink
                    to="/contact"
                    activeStyle={{
                      color: "white",
                    }}
                  >
                    contact
                  </NavLink>
                  <NavLink
                    to="/impressum"
                    activeStyle={{
                      color: "white",
                    }}
                  >
                    impressum
                  </NavLink>
                </nav>
              </div>
              <div className="header-extended-bg" />
              <div className="content">
                <Routes />
              </div>
            </div>
            <Cookies />
          </Cursor>
        </Router>
      </LoadingScreen>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js